var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "viewer-office" },
    [
      _vm.readySrc
        ? _c("vue-office-docx", {
            key: _vm.renderKey,
            staticStyle: { height: "100%", width: "100%" },
            attrs: { src: _vm.readySrc },
            on: { rendered: _vm.onRendered, error: _vm.onError },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }